import React from 'react';
import {
  AccountPortalShell,
  HCard,
  SerifHeading,
  SectionLabel,
  HPrimaryButton,
  HGhostButton,
} from '../h';

/* v9 mockup 1.8 — Philosophy welcome.

   Shown the first time a hearthOwner signs in after their devices have arrived
   and they're about to start account setup. Acts as a soft onboarding step
   before the AccountSetup wizard. Wired in as step 0 of AccountSetup —
   not a separately-routed page in App.js.

   Props:
     - onContinue: invoked when the user taps "Let's begin"
     - onSignOut:  invoked when the user taps Sign out (top-right)
*/
export function PhilosophyWelcome({ onContinue, onSignOut }) {
  return (
    <AccountPortalShell
      rightSlot={
        <HGhostButton onClick={onSignOut} className="text-[12px]">
          Sign out
        </HGhostButton>
      }
    >
      <div className="px-4 pt-6 pb-4">
        <SectionLabel className="mb-3 text-slate-400">Before you begin</SectionLabel>
        <SerifHeading size="3xl" className="mb-4">
          Higlo isn&rsquo;t<br />a video call.
        </SerifHeading>
        <p className="text-[14px] text-slate-700 leading-relaxed mb-4">
          There&rsquo;s no ringing, no scheduling, nothing to miss.
        </p>
        <p className="text-[14px] text-slate-700 leading-relaxed mb-4">
          Your Hearth is a <strong>space</strong> where your family can see each
          other, not a call you have to take. Open your Hearth; if someone&rsquo;s there,
          you&rsquo;re together. If they&rsquo;re not, that&rsquo;s fine too.
        </p>

        <HCard variant="next" className="p-4 mb-4">
          <SectionLabel className="mb-2 text-blue-700">
            Now your Hearths have arrived — two quick stages
          </SectionLabel>
          <div className="flex items-center gap-3 mb-2">
            <div className="w-7 h-7 rounded-full flex items-center justify-center text-[12px] font-semibold bg-slate-900 text-white">
              1
            </div>
            <div className="text-[13px] text-slate-800">
              <strong>Set up your account</strong> — 2 minutes
            </div>
          </div>
          <div className="flex items-center gap-3">
            <div className="w-7 h-7 rounded-full flex items-center justify-center text-[12px] font-semibold bg-slate-300 text-slate-600">
              2
            </div>
            <div className="text-[13px] text-slate-600">
              <strong>Set up each Hearth</strong> — plug in and connect to WiFi
            </div>
          </div>
        </HCard>

        <HPrimaryButton
          onClick={onContinue}
          className="w-full"
          style={{ padding: '14px', fontSize: '15px' }}
        >
          Let&rsquo;s begin
        </HPrimaryButton>
      </div>
    </AccountPortalShell>
  );
}
